module.exports = __webpack_public_path__ + "static/media/fteIcon.b1400f0f.svg";